export const eventPropagationListener = (eventName: string, callback: () => void) => {
    window.addEventListener(eventName, callback, true);
}